// extracted by mini-css-extract-plugin
export default {"container":"studio_container__m9UQy","header":"studio_header__dNWN2","dashboard_container":"studio_dashboard_container__aRLee","content":"studio_content__rTjIf"};